import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  InfoOutlined,
  DateRangeOutlined,
  DescriptionOutlined,
  CarCrashOutlined,
  DirectionsCarOutlined,
  Person,
  AccountCircleOutlined,
} from "@mui/icons-material";

import { useIncidentReportDetailContext } from "contexts/IncidentReportDetailContext"; // Context for incident report details
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";

const statusStyles = {
  Resolved: {
    backgroundColor: "#EBF5FB",
    textColor: "green",
  },
  Pending: {
    backgroundColor: "#FADBD8",
    hoverBackgroundColor: "#F5B7B1",
    textColor: "#C0392B",
  },
  default: {
    backgroundColor: "#E9ECEF",
    hoverBackgroundColor: "#D6D8DB",
    textColor: "#6C757D",
  },
};

const getStatusStyle = (status) => statusStyles[status] || statusStyles.default;

const IncidentReportBasicDetail = () => {
  const { incidentReportDetail, loadingIncidentReport } =
    useIncidentReportDetailContext();

  return !loadingIncidentReport ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <CarCrashOutlined color="primary" />}
            title="Incident ID"
            subtitle={incidentReportDetail?.incidentId || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <DirectionsCarOutlined color="primary" />}
            title="Vehicle"
            subtitle={
              incidentReportDetail.vehicleId?.registration_number || "N/A"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Driver"
            subtitle={
              incidentReportDetail?.driverId &&
              typeof incidentReportDetail.driverId === "object"
                ? incidentReportDetail.driverId.driverId
                : incidentReportDetail?.driverId || "N/A"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <CarCrashOutlined color="primary" />}
            title="Incident Type"
            subtitle={incidentReportDetail?.incidentType?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Incident Date"
            subtitle={
              incidentReportDetail?.incidentDate
                ? localizeDateTimeShort(incidentReportDetail?.incidentDate)
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
            subtitle={
              <Box
                display="flex"
                flexDirection="column"
                alignItems="start"
                mt={1}
              >
                <Chip
                  label={incidentReportDetail?.status?.name || "Unknown"}
                  style={{
                    backgroundColor: getStatusStyle(
                      incidentReportDetail?.status?.name
                    ).backgroundColor,
                    color: getStatusStyle(incidentReportDetail?.status?.name)
                      .textColor,
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "0.7rem",
                    height: "20px",
                    padding: "0 6px",
                    borderRadius: "12px",
                    marginTop: "4px",
                    width: "auto",
                  }}
                />
              </Box>
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountCircleOutlined color="primary" />}
            title="Added By"
            subtitle={incidentReportDetail?.addedBy?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={12}>
          <InformationTile
            icon={() => <DescriptionOutlined color="primary" />}
            title="Description"
            subtitle={incidentReportDetail?.description || "N/A"}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default IncidentReportBasicDetail;
